import { render, staticRenderFns } from "./horizontal-banner.vue?vue&type=template&id=6c950069&scoped=true&"
import script from "./horizontal-banner.vue?vue&type=script&lang=js&"
export * from "./horizontal-banner.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-banner.vue?vue&type=style&index=0&id=6c950069&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c950069",
  null
  
)

export default component.exports